<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
  <template v-if="$user.main_account==true && $active_account==null">
    <template v-for="sub_account,index in $user.sub_accounts">
      <center>
        <h1>Account:{{ sub_account.brand_name?sub_account.brand_name:sub_account.name }}</h1>
      </center>
    <template v-if="subscribed[index]">
      <b-card  title="Subscription" v-if="!displayChangeSub">
        <br />
        <b-row>
          <b-col cols="3">
            Your subscription
            <div class="grey-color">Manage your plan & credits</div>
          </b-col>
          <b-col cols="9" class="plan-col">
            <div class="plan-header">
            <h3>{{ current_subscription[index].subscription_type.name }}</h3>
            <div>
              <b-button
                v-b-modal.modal-danger
                  variant="danger"
                  @click="current_subscription_id_delete=current_subscription[index].id"
                >
                  Cancel subscription
                </b-button>

                <b-button
                @click="displayChangeSub=true"
                  variant="secondary"
                  class="ml-2"
                >
                  Change plan
                </b-button>
              </div>
            </div>
            <br />
            <b-row>
              <div class="col-md-6">
                <b-card>
                  <div class="header-card">
                    Included in your plan
                  </div>
                  <br />
                  <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>White-label Mobile App</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Eyewear Digitization Studio</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Face Scan Measurements</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Face Report Generation</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Catalog Filtering & Recommendations</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Complete Product Page</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Dashboard</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Activity Logs</span>
                    </div>

                </b-card>
              </div>
              <div class="col-md-6">
                <b-card >
                  <div class="header-card">
                    Billing and payment
                  </div>
                  <br />
                  <div class="header-card" v-for="payment_method in payment_methods[index]">
                    <div class="title-card">
                      <img src="@/assets/images/cb.svg" alt="Credit Card" />
                      <span>{{payment_method.card.brand.charAt(0).toUpperCase() + payment_method.card.brand.slice(1)}} ending by {{payment_method.card.last4}}</span>
                    </div>
                  </div>
                  <br />
                  <b-button variant="primary" @click="displayCardModal(current_subscription[index].customer_stripe_id,index)">Change payment method</b-button>
                  <br /><br />
                  <div class="header-card">
                    <div class="title-card">
                      <img src="@/assets/images/calendar.svg" alt="Credit Card" />
                      <span>{{ current_subscription[index].subscription_type.price }}€ / month<br />Next payment on {{scan_reset_date[index]}}</span>
                    </div>
                  </div>

              

                </b-card>
              </div>
            </b-row>
            <b-row>
              <div class="col-md-12">
                <b-card >
                
                  <div class="header-card" v-for="element in current_subscription[index].subscription_type.subscription_elements">
                    <div class="title-card" v-if="element.counter_type == 'scans'">
                      <img src="@/assets/images/scans.svg" alt="Credit Card" />
                      <span>Included scans<br /><span class="grey-color">Scan overage: {{ element.amount }}€ / scan</span></span>
                    </div>
                    <div class="sub-right">{{ element.quota }}</div>
                  </div>
                </b-card>
              </div>
            </b-row>
          </b-col>
        </b-row>
      
      </b-card>

      
    </template>

   
    <b-row v-if="!subscribed[index] || displayChangeSub" class="subscription-row">
      <SubscriptionPopupContent  :current_user_id="sub_account.id" :current_subscription="current_subscription[index]" :subscriptions="subscriptions" />
      
    </b-row>
 
  </template>
  </template>
  <template v-else>
    <template v-if="subscribed">
      <b-card  title="Subscription" v-if="!displayChangeSub">
        <br />
        <b-row>
          <b-col cols="3">
            Your subscription
            <div class="grey-color">Manage your plan & credits</div>
          </b-col>
          <b-col cols="9" class="plan-col">
            <div class="plan-header">
            <h3>{{ current_subscription.subscription_type.name }}</h3>
            <div>
              <b-button
                v-b-modal.modal-danger
                  variant="danger"
                  @click="current_subscription_id_delete=current_subscription.id"
                >
                  Cancel subscription
                </b-button>

                <b-button
                @click="displayChangeSub=true"
                  variant="secondary"
                  class="ml-2"
                >
                  Change plan
                </b-button>
              </div>
            </div>
            <br />
            <b-row>
              <div class="col-md-6">
                <b-card>
                  <div class="header-card">
                    Included in your plan
                  </div>
                  <br />
                  <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>White-label Mobile App</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Eyewear Digitization Studio</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Face Scan Measurements</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Face Report Generation</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Catalog Filtering & Recommendations</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Complete Product Page</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Dashboard</span>
                    </div>
                    <div class="sub-left">
                      <img src="@/assets/images/check.svg" alt="Scan" />
                      <span>Activity Logs</span>
                    </div>

                </b-card>
              </div>
              <div class="col-md-6">
                <b-card >
                  <div class="header-card">
                    Billing and payment
                  </div>
                  <br />
                  <div class="header-card" v-for="payment_method in payment_methods">
                    <div class="title-card">
                      <img src="@/assets/images/cb.svg" alt="Credit Card" />
                      <span>{{payment_method.card.brand.charAt(0).toUpperCase() + payment_method.card.brand.slice(1)}} ending by {{payment_method.card.last4}}</span>
                    </div>
                  </div>
                  <br />
                  <b-button variant="primary" @click="displayCardModal(current_subscription.customer_stripe_id,null)">Change payment method</b-button>
                  <br /><br />
                  <div class="header-card" >
                    <div class="title-card">
                      <img src="@/assets/images/calendar.svg" alt="Credit Card" />
                      <span>{{ current_subscription.subscription_type.price }}€ / month<br />Next payment on {{ scan_reset_date }}</span>
                    </div>
                  </div>

              

                </b-card>
              </div>
            </b-row>
            <b-row>
              <div class="col-md-12">
                <b-card >
                
                  <div class="header-card" v-for="element in current_subscription.subscription_type.subscription_elements">
                    <div class="title-card" v-if="element.counter_type == 'scans'">
                      <img src="@/assets/images/scans.svg" alt="Credit Card" />
                      <span>Included scans<br /><span class="grey-color">Scan overage: {{ element.amount }}€ / scan</span></span>
                    </div>
                    <div class="sub-right">{{ element.quota }}</div>
                  </div>
                </b-card>
              </div>
            </b-row>
          </b-col>
        </b-row>
      
      </b-card>

      
    </template>

    <template v-if="$user.is_demo==true">
      <br />
      Your account is on demo mode.
    </template>
    <b-row v-else-if="!subscribed || displayChangeSub" class="subscription-row">
      <SubscriptionPopupContent  :current_user_id="$active_account?$active_account.id:$user.id" :current_subscription="current_subscription" :subscriptions="subscriptions" />
      
    </b-row>
  </template>

    <b-modal
          id="modal-change"
          cancel-variant="secondary"
          cancel-title="No"
          ok-variant="danger"
          ok-title="Yes"
          @ok="changeSubscription(stripe_id,id_sub)"
          modal-class="modal-danger"
          centered
          title="Are you sure ?"
        >
          <b-card-text>
            Attention, this action is irreversible ! Are you sure you want to change your subscription ?
          </b-card-text>
        </b-modal>
    <b-modal
          id="modal-danger"
          cancel-variant="secondary"
          cancel-title="No"
          ok-variant="danger"
          ok-title="Yes"
          @ok="deleteSubscription()"
          modal-class="modal-danger"
          centered
          title="Are you sure ?"
        >
          <b-card-text>
            Attention, this action is irreversible ! Are you sure you want to delete this subscription ?
          </b-card-text>
        </b-modal>
        <b-modal
          id="modal-cb"
          cancel-variant="secondary"
          cancel-title="Cancel"
          ok-variant="primary"
          ok-title="Edit"
          @ok="editPaymentMethod"
         
                                 
          centered
          title="Edit payment method"
        >
        <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
            <b-card-text>
              <div id="payment-element"></div>
            </b-card-text>
          </b-overlay>
        </b-modal>
  </b-overlay>

</template>
<script>
import {BModal, BButton, BOverlay, BRow, BCol, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import SubscriptionPopupContent from './popup/SubscribtionPopupContent.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BModal,
    BButton,
    BRow,
    BCol,
    SubscriptionPopupContent
  },
  data() {
    return {
      customer_stripe_id:null,
      displayChangeSub:false,
      subscriptions:[],
      currentChangeChoice:null,
      pageLength: 3,
      scan_reset_date:null,
      subscribed:false,
      totalRows:0,
      current_subscription_id_delete:null,
      current_subscription:null,
      currentPage:1,
      stripe_id:null,
      id_sub:null,
      invoices:null,
      dir: false,
      payment_methods:null,
      loading:true,
      stripe:null,
      client_secret:null,
      selectedItem:null,
      columns: [
        {
          label: 'Code',
          field: 'code',
        },
        {
          label: 'Nom',
          field: 'name',
        },
        {
          label: 'Montant',
          field: 'amount',
        },
        {
          label: 'Action',
          field: 'action',
        }
        
      ],
      rows: [],
      searchTerm: '',
      cardElement:null,

    }
  },
  computed: {
    activeAccount() {
      return this.$active_account
    },
  },
  watch: {
    activeAccount() {
      this.loadSubscriptionData()
    },
  },
  methods: {
    async loadSubscriptionData() {
      this.loading = true
      this.displayChangeSub = false

      if (this.$user.main_account == true && this.$active_account == null) {
        let current_subscription = []
        let invoices_arr = []
        let payment_methods_arr = []
        let subscribed = []
        this.scan_reset_date = []
        for (let i = 0; i < this.$user.sub_accounts.length; i++) {
          let subscription = await APIRequest.list_with_request('subscriptions', '?user=' + this.$user.sub_accounts[i].id + '&status=active&order=desc')
          if (subscription[0].length > 0) {
            subscribed.push(true)
            current_subscription.push(subscription[0][0])
            //let payment_methods = await APIRequest.get_request('get-payment-methods/' + subscription[0][0].customer_stripe_id, '')
            let payment_method = await APIRequest.get_request('get-payment-method/' + subscription[0][0].stripe_id, '')

            //console.log(payment_method.data)
            payment_methods_arr.push([payment_method.data.data])

            let response = await APIRequest.get_request('get-subscription/' + subscription[0][0].stripe_id + '/' + subscription[0][0].customer_stripe_id)
            let sub = response.data.data

            for (let i = 0; i < sub.items.data.length; i++) {
              let item = sub.items.data[i]
              if (item.plan.meter) {
                let dte=item.current_period_end
                this.scan_reset_date.push(this.formatDate(dte))
              }
            }
          }
          else 
          {
            this.scan_reset_date.push(false)
          }
        }
        this.current_subscription = current_subscription
        this.payment_methods = payment_methods_arr
        this.subscribed = subscribed
        this.invoices = invoices_arr

        let subscriptions = await APIRequest.list('subscription-types')
        this.subscriptions = subscriptions[0]
        this.totalRows = subscriptions[1]
      } else {
        let user_id
        if (this.$active_account == null) {
          user_id = localStorage.id_user_senseye_auth
        } else {
          user_id = this.$active_account.id
        }
        let subscription = await APIRequest.list_with_request('subscriptions', '?user=' + user_id + '&status=active&order=desc')

        if (subscription[0].length > 0) {
          this.subscribed = true

          let response = await APIRequest.get_request('get-subscription/' + subscription[0][0].stripe_id + '/' + subscription[0][0].customer_stripe_id)
          let sub = response.data.data

          for (let i = 0; i < sub.items.data.length; i++) {
            let item = sub.items.data[i]
            if (item.plan.meter) {
              this.scan_reset_date = item.current_period_end
              this.scan_reset_date = this.formatDate(this.scan_reset_date)
            }
          }
       
          this.current_subscription = subscription[0][0]
          let payment_methods = await APIRequest.get_request('get-payment-method/' + this.current_subscription.stripe_id, '')

          this.payment_methods = [payment_methods.data.data]

         

          let subscriptions = await APIRequest.list('subscription-types')
          this.subscriptions = subscriptions[0]
          this.totalRows = subscriptions[1]
        } else {
          this.scan_reset_date = null
          this.subscribed = false
          this.current_subscription = null
          this.payment_methods = null
          this.invoices = null
          let subscriptions = await APIRequest.list('subscription-types')
          this.subscriptions = subscriptions[0]
          this.totalRows = subscriptions[1]
        }
      }

      this.loading = false
    },
    formatDate(timestamp){
      let date = new Date(timestamp * 1000); // conversion en millisecondes

      let jour = String(date.getDate()).padStart(2, '0');
      let mois = String(date.getMonth() + 1).padStart(2, '0'); // mois de 0 à 11
      let annee = date.getFullYear();

      let dateFormatee = `${jour}/${mois}/${annee}`;
      return dateFormatee
    },
    formatDate2(timestamp){
      let date = new Date(timestamp).toLocaleDateString('fr-FR'); // conversion en millisecondes

      return date
    },
    async displayCardModal(customer_stripe_id,index){

      this.index=index
      this.customer_stripe_id=customer_stripe_id
      this.$bvModal.show('modal-cb')

      let client_secret=await APIRequest.get_request('create-setup-intent/'+customer_stripe_id, '')

      this.stripe = Stripe('pk_test_51Ix7q2BGInQvVcEzPCh5bh4SVvsT3uAMwIB9bMqdesgZyQnsDeyAkFuVukFRiKKAELjWRkj8HRqKTwo9CnNTGoUI001k8WNdy2');
      this.client_secret=client_secret.data.client_secret
     
      const elements = this.stripe.elements();
      this.cardElement = elements.create("card");
      this.cardElement.mount("#payment-element");
      
    },
    async changeSubscription(stripe_id, id)
    {
      this.loading=true
      let update=await APIRequest.get_request('change-plan/'+stripe_id+'/'+this.currentChangeChoice+'/'+id, '')
    
      if(update.data.status=="success")
      {

      let subscription=await APIRequest.list_with_request('subscriptions', '?user='+localStorage.id_user_senseye_auth+'&status=active&order=desc')
      if(subscription[0].length>0)
      {
    
      this.current_subscription=subscription[0][0]

      }
      this.displayChangeSub=false

      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'L\'abonnement a été modifié !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    }
    else
    {
      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Une erreur est survenue.',
          icon: 'AlertCircleIcon',
          variant: 'warning',
        },
      })
    }
    },
    async editPaymentMethod(bvModalEvent){
      
      this.loading=true
      
      bvModalEvent.preventDefault();
        const { setupIntent, error } = await this.stripe.confirmCardSetup(
            this.client_secret,
            {
                payment_method: {
                    card: this.cardElement,
                },
            }
        );

        if (error) {
            alert(error.message);
            return;
        }

        let update=await APIRequest.get_request('update-payment-method/'+this.customer_stripe_id+'/'+setupIntent.payment_method, '')

        if(update.data.status=="success")
        {
          let payment_methods=await APIRequest.get_request('get-payment-methods/'+this.customer_stripe_id, '')
    
          
          this.payment_methods=payment_methods.data.data
          this.$bvModal.hide('modal-cb')
          
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Méthode de paiement mise à jour !',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.loading=false
        }
        else
        {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
        }
    },
    async deleteSubscription()
    {
      this.loading=true
      try {
        await APIRequest.delete('subscriptions',this.current_subscription_id_delete)
        let subscriptions=await APIRequest.list('subscription-types')
        this.subscriptions=subscriptions[0]
        this.loading=false
        this.subscribed=false
        this.current_subscription=null
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Subscription has been deleted !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'An error has occurred.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    }
  },
  async mounted() {
    await this.loadSubscriptionData()
  }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-good-table.scss';

.plan-header
{
  display:flex;
  justify-content: space-between;
  align-items: flex-start;
}
.plan-col
{
  padding:20px;
  background:#f1f1f1;
  border-radius:5px;
 
}


</style>
